/**
 * The Q&A of a `?inquiry_id=` deep link, when it is a numeric id. The API's
 * routes accept 1 to 18 digits only (any other value is a 404), so a mangled
 * link opens the newest Q&A instead. Leading zeros are dropped: the page
 * compares ids as strings ("0856" would never match Q&A 856).
 */
export const linkedInquiryId = (
  params: URLSearchParams,
): string | undefined => {
  const id = params.get('inquiry_id')?.trim();
  if (!id || !/^[0-9]{1,18}$/.test(id)) return undefined;
  const plain = id.replace(/^0+(?=[0-9])/, '');
  return plain === '0' ? undefined : plain;
};
